'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HublyticsApi = require('../api/HublyticsApi');

var _HublyticsApi2 = _interopRequireDefault(_HublyticsApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FIRE_ALARM_APP_NAME = 'firealarm';
var FIRE_ALARM_SCREEN_NAME = 'firealarm-screen';

var HUBSPOT_ACCOUNT_ID = 53;
var USAGE_TYPE = 'USAGE';

var Analytics = function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
  }

  _createClass(Analytics, [{
    key: 'trackUsage',
    value: function trackUsage(event, alarmId, alarmRevision) {
      var appName = hubspot.bender && hubspot.bender.currentProject;
      var currentUserEmail = this.getCurrentUserEmail();
      var currentPortalId = this.getCurrentPortalId();
      var now = new Date().getTime();
      var trackingEvent = this.getTrackingEvent(event, alarmId, alarmRevision, appName, currentUserEmail, currentPortalId, now);

      _HublyticsApi2.default.postEvent(trackingEvent, now);
    }
  }, {
    key: 'getTrackingEvent',
    value: function getTrackingEvent(eventName, alarmId, alarmRevision, appName, userEmail, portalId, timestamp) {
      var identifier = 'alarm-' + alarmId + '-revision-' + alarmRevision;

      var event = {
        hublytics_account_id: HUBSPOT_ACCOUNT_ID,
        what_event: eventName,
        what_event_class: USAGE_TYPE,
        where_app: FIRE_ALARM_APP_NAME,
        where_screen: FIRE_ALARM_SCREEN_NAME,
        where_subscreen: appName,
        who_team_identifier: portalId,
        when_timestamp: timestamp,
        where_app_override: FIRE_ALARM_APP_NAME,
        what_value_str: identifier,
        what_extra_json: JSON.stringify({
          alarm_id: alarmId,
          alarm_revision: alarmRevision
        })
      };

      if (userEmail && portalId) {
        event.who_identifier_v2 = 'EMAIL:::' + userEmail + ':::' + portalId;
      }

      return event;
    }
  }, {
    key: 'getCurrentUser',
    value: function getCurrentUser() {
      return window.hubspot && window.hubspot.user;
    }
  }, {
    key: 'getCurrentUserEmail',
    value: function getCurrentUserEmail() {
      var currentUser = this.getCurrentUser();
      return currentUser && currentUser.email;
    }
  }, {
    key: 'getCurrentPortal',
    value: function getCurrentPortal() {
      return window.hubspot && window.hubspot.portal;
    }
  }, {
    key: 'getCurrentPortalId',
    value: function getCurrentPortalId() {
      var currentPortal = this.getCurrentPortal();
      return currentPortal && currentPortal.id;
    }
  }]);

  return Analytics;
}();

exports.default = new Analytics();
module.exports = exports['default'];